import { LOCAL_STORAGE_KEYS } from "constants/LocalStorageItems";
import { useFeatureFlag } from "hooks/useFeatureFlag";

export function useVoltAccountsFeatureFlag() {
  return useFeatureFlag(LOCAL_STORAGE_KEYS.voltAccounts);
}
